import api from '@/api/app'
const proList = {
  proList: {
    viewInfo: {
      obj: {
        tabs: [
          {
            id: 111,
            key: 0,
            name: '装备清单',
            type: 'text'
          }
          // 暂时隐藏我的清单
          // {
          //   id: 222,
          //   key: 1,
          //   name: '我的清单',
          //   type: 'text'
          // }
        ],
        table1: [
          {
            type: 'text',
            model: 'serialNum',
            label: '序号',
            width: '75',
            align: 'center'
          },
          {
            type: 'text',
            model: 'name',
            label: '清单名称',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'category_name',
            label: '学科',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'created_date',
            label: '创建时间',
            width: '150',
            align: 'center'
          },
          {
            type: 'slot',
            model: 'operate',
            label: '操作',
            width: '',
            align: 'center'
          }
        ],
        table2: [
          {
            type: 'text',
            model: 'name',
            label: '产品名',
            width: '100',
            align: 'center'
          },
          {
            type: 'text',
            model: 'brand_name',
            label: '产品品牌名',
            width: '100',
            align: 'center'
          },
          {
            type: 'slot',
            model: 'operate',
            label: '产品描述',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'num',
            label: '产品数量',
            width: '100',
            align: 'center'
          },
          {
            type: 'text',
            model: 'unit_price',
            label: '单价/元',
            width: '100',
            align: 'center'
          },
          {
            type: 'text',
            model: 'unit',
            label: '产品单位',
            width: '100',
            align: 'center'
          },
          {
            type: 'text',
            model: 'commodity_total_price',
            label: '合计/元',
            width: '100',
            align: 'center'
          }
        ]
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      subjects: (obj) => {
        return new Promise((resolve) => {
          api.square.retrieve.subjects(obj).then((res) => {
            if (res.data.length) {
              res.data.map(item => {
                item.label = item.name
                item.value = item.id
                item.children.map(iten => {
                  iten.label = iten.name
                  iten.value = iten.id
                })
              })
            }
            resolve(res.data)
          })
        })
      },
      data1: (obj) => {
        return new Promise((resolve) => {
          api.proList.retrieve.data(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map((item, index) => {
                item.serialNum = index + 1
              })
            }
            resolve(res.data)
          })
        })
      },
      dto: (obj) => {
        return new Promise((resolve) => {
          api.proList.retrieve.dto(obj).then((res) => {
            resolve(res.data)
          })
        })
      }
    }
  }
}
export default proList
